import React from "react";
import { Box } from "@mui/material";
import LanguageSelector from "./LanguageSelector/LanguageSelector";
import WelcomeHero from "./Welcome/WelcomeHero";
import WelcomeHeroCta from "./Welcome/WelcomeHeroCta";
import WelcomeAboutSection from "./Welcome/WelcomeAboutSection";
import WelcomeFeaturesSection from "./Welcome/WelcomeFeaturesSection";
import WelcomeFaqSection from "./Welcome/WelcomeFaqSection";
import WelcomeFooter from "./Welcome/WelcomeFooter";
import WelcomeParallaxSection from "./Welcome/WelcomeParallaxSection";
import {
  welcomeHeroGroupSx,
  welcomePageStackSx
} from "./Welcome/welcomeSectionStyles";

const Welcome = () => {
  return (
    <Box
      component="main"
      data-testid="welcome-page"
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "#fff"
      }}
    >
      <Box
        data-testid="welcome-language-bar"
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          pt: "env(safe-area-inset-top, 0px)",
          pr: { xs: 1.5, sm: 2 },
          py: { xs: 1, sm: 1.5 },
          zIndex: (theme) => theme.zIndex.appBar
        }}
      >
        <LanguageSelector />
      </Box>
      <Box sx={welcomePageStackSx}>
        <Box sx={welcomeHeroGroupSx}>
          <WelcomeHero />
          <WelcomeHeroCta />
        </Box>
        <WelcomeParallaxSection index={0} offset={90}>
          <WelcomeAboutSection />
        </WelcomeParallaxSection>
        <WelcomeParallaxSection index={1} offset={90}>
          <WelcomeFeaturesSection />
        </WelcomeParallaxSection>
        <WelcomeParallaxSection index={2} offset={90}>
          <WelcomeFaqSection />
        </WelcomeParallaxSection>
        <WelcomeFooter />
      </Box>
    </Box>
  );
};

export default Welcome;
